import React from 'react'
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

const headCells = [
  { id: 'orderId', numeric: false, disablePadding: true, label: 'OrderID' },
  { id: 'orderType', numeric: false, disablePadding: true, label: 'OrderType' },
  { id: 'seller', numeric: false, disablePadding: false, label: 'Seller' },
  { id: 'amount', numeric: false, disablePadding: false, label: 'Amount' },
  { id: 'payment', numeric: false, disablePadding: false, label: 'Payment' },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
];

function EnhancedTableHead(props) {
  const { styles, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding={'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
              sx={styles.fontSize}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span style={styles.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default EnhancedTableHead;